import { SignIn, SignUp } from "@clerk/clerk-react";

const Login = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <SignIn 
        routing="path" 
        path="/login"
        redirectUrl="/dashboard"
      />
    </div>
  );
};

export const SignUpPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <SignUp 
        routing="path" 
        path="/sign-up"
        redirectUrl="/dashboard"
      />
    </div>
  );
};

export default Login; 